import {AnyAction} from 'redux'
import {changeEventAction} from '../actions/event'
import {ScheduleState} from '../types/state'

const defaultState = {
  facets: {},
  items: [],
  limit: 0,
  offset: 0,
  total: 0,
} as ScheduleState

export const schedule = (state: ScheduleState = defaultState, action: AnyAction) => {
  switch (action.type) {
    case changeEventAction.toString():
      return action.payload.schedule
    default:
      return state
  }
}
